import { CounterInputField } from "@ps-design-system/components/CounterInput";

import { useIntl } from "react-intl-compat";
import {
  MAX_MINIMUM_DURATION_HOURS,
  MIN_MINIMUM_DURATION_HOURS,
} from "~/app/your-space/activate-listings/ActivateListingsPage.consts";

/** Minimum number of hours a booking must last. */
const MinimumDurationField = () => {
  const intl = useIntl();

  return (
    // @ts-ignore - issues in design system
    <CounterInputField
      fullWidth
      className="tw-max-w-[300px]"
      name="minimumDuration"
      min={MIN_MINIMUM_DURATION_HOURS}
      max={MAX_MINIMUM_DURATION_HOURS}
      label={intl.formatMessage({
        id: "hosting.listing_rules.minimum_duration_label",
        defaultMessage: "Minimum hours",
      })}
      required
      placeholder="4"
      testId="rules-form-minimum-duration-input"
    />
  );
};

export { MinimumDurationField };
